// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import ReactGA from "react-ga4";

var generalCommonJS = require("../js/generalCommon.js")

// Logout
const Logout = () => {

    useEffect(() => {        
        Logout()  
    }, []);

    function Logout(){
        generalCommonJS.limpiarDatosSesion()
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'LOGOUT', 'LOGOUT - Correcto', "", "")        
        window.location.href = "/"            
    }

    return (
        <main>               
        </main>                          
    )

}

export default Logout